import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppAuthProvider } from './auth';
import App from './App';
import { PasswordGate } from './components/PasswordGate';
import './index.css';
import './features/typography/typography.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PasswordGate>
      <AppAuthProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AppAuthProvider>
    </PasswordGate>
  </React.StrictMode>
);
